<div
	class="story-pop-up"
	(click)="handleSlideClick($event)"
>
	<button
		class="button-reset close"
		type="button"
		(click)="close()"
	></button>

	<div
		class="story-pop-up__content"
		#storyContent
	>
		@if (storiesList?.slideChange$ | async; as curSlide) {
			<div class="story-slider">
				@for (slide of storiesList?.story?.slides; track slide; let i = $index) {
					<div class="story-slider__item">
						<div class="story-slider__line-underlay"></div>
						<div
							class="story-slider__line"
							[ngClass]="{
								'story-slider__line--fill': i < curSlide.index,
								'story-slider__line--active': curSlide.index === i,
							}"
							[ngStyle]="{
								'animation-duration': slide.displayTimeSeconds + 's',
								'animation-play-state': animationState$ | async,
							}"
						></div>
					</div>
				}
			</div>
		}

		<!-- for desktop -->
		<!-- <div class="tns-controls">
    <button
      class="tns-controls__btn tns-controls__btn--prev"
      (click)="prev()"
    ></button>
    <button
      class="tns-controls__btn tns-controls__btn--next"
      (click)="next()"
      [attr.disabled]="storiesList?.isFinished$ | async"
    ></button>
  </div> -->

		@if (storiesList?.stories) {
			<div class="story-pop-up__slider">
				@if (showStoryLoader$ | async) {
					<div class="story-pop-up__loader">
						<app-loader></app-loader>
					</div>
				}
				@if (storiesList?.slideChange$ | async; as curSlide) {
					<div class="story-pop-up__slider-item">
						<app-adaptive-image
							class="story-pop-up__slider-item-image"
							[image]="$any(curSlide).lightTheme"
						></app-adaptive-image>
						@if (isShowButton(curSlide)) {
							<a
								class="button story-pop-up__slider-item-link"
								(click)="handleSlideButtonClick(curSlide)"
							>
								{{ curSlide.buttonName }}
							</a>
						}
					</div>
				}
			</div>
		}
	</div>
</div>
